// extracted by mini-css-extract-plugin
export default {"resetPwd":"ResetPassword_resetPwd__81Jdq","centered":"ResetPassword_centered__wXzS6","button":"ResetPassword_button__Y+2Ou"};